import 'virtual:uno.css';
import 'animate.css';

import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
import '@fortawesome/fontawesome-free/scss/brands.scss';
import 'bootstrap-icons/font/bootstrap-icons.scss';
import 'bootstrap/scss/bootstrap.scss';
import './assets/css/main.scss';
import './assets/css/responsive.scss';

import { createApp, ref } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import router from './router';

import 'lazysizes';

const app = createApp(App);
const appLoading = ref(false);

app.provide('app-loading', appLoading);

app.use(createPinia());
app.use(router);

router.isReady().then(() => {
  app.mount('#app');

  const element = document.querySelector('#preloader');
  element?.classList.add('animate__animated', 'animate__fadeOut');

  element?.addEventListener('animationend', () => {
    element.remove();
  });
});
